import { Box, Grid, Typography } from '@mui/material';
import { ShowChart } from '@mui/icons-material';
import {
  DASHBOARD_APPLICATION_STATUS_PERMISSIONS,
  DASHBOARD_APPLICATION_YEAR_PERMISSIONS,
  DASHBOARD_FORMS_PERMISSIONS,
  DASHBOARD_INSPECTOR_PERMISSIONS,
  DASHBOARD_NURSERY_PERMISSIONS,
  DASHBOARD_YEAR_TREND_PERMISSIONS,
  hasAnyPermission,
} from '~/lib/permissions';
import { ApplicationStatusDistributionChart } from './ApplicationStatusDistributionChart';
import { FormCompletionSummaryChart } from './FormCompletionSummaryChart';
import { InspectorPerformanceChart } from './InspectorPerformanceChart';
import { NewVsRenewalsChart } from './NewVsRenewalsChart';
import { RegionalNurseryDistributionChart } from './RegionalNurseryDistributionChart';
import { YearlyRegistrationTrendChart } from './YearlyRegistrationTrendChart';

type DashboardChartsSectionProps = {
  regionalCode: string;
  permissionSet: Set<string>;
};

export function DashboardChartsSection({
  regionalCode,
  permissionSet,
}: DashboardChartsSectionProps) {
  const showAppStatus = hasAnyPermission(permissionSet, DASHBOARD_APPLICATION_STATUS_PERMISSIONS);
  const showYearTrend = hasAnyPermission(permissionSet, DASHBOARD_YEAR_TREND_PERMISSIONS);
  const showNursery = hasAnyPermission(permissionSet, DASHBOARD_NURSERY_PERMISSIONS);
  const showNewVsRenewals = hasAnyPermission(permissionSet, DASHBOARD_APPLICATION_YEAR_PERMISSIONS);
  const showForms = hasAnyPermission(permissionSet, DASHBOARD_FORMS_PERMISSIONS);
  const showInspector = hasAnyPermission(permissionSet, DASHBOARD_INSPECTOR_PERMISSIONS);

  return (
    <Box sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <ShowChart color="primary" />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Analytics Charts
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {showAppStatus ? (
          <Grid size={{ xs: 12, lg: 6 }}>
            <ApplicationStatusDistributionChart regionalCode={regionalCode} />
          </Grid>
        ) : null}

        {showYearTrend ? (
          <Grid size={{ xs: 12, lg: showNursery ? 6 : 12 }}>
            <YearlyRegistrationTrendChart />
          </Grid>
        ) : null}

        {showNursery ? (
          <Grid size={{ xs: 12, lg: showYearTrend ? 6 : 12 }}>
            <RegionalNurseryDistributionChart />
          </Grid>
        ) : null}

        {showNewVsRenewals ? (
          <Grid size={12}>
            <NewVsRenewalsChart regionalCode={regionalCode} />
          </Grid>
        ) : null}

        {showForms ? (
          <Grid size={{ xs: 12, lg: 6 }}>
            <FormCompletionSummaryChart regionalCode={regionalCode} />
          </Grid>
        ) : null}

        {showInspector ? (
          <Grid size={{ xs: 12, lg: 6 }}>
            <InspectorPerformanceChart regionalCode={regionalCode} />
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
}
